import React from 'react';

const WoltSpecialIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
      <path d="M15.4573 8.19328C16.1799 8.88894 16.1799 10.0147 15.4573 10.7104L11.1553 14.8403C10.4305 15.5337 9.25813 15.5337 8.53333 14.8403L0.547332 7.17312C0.199215 6.84054 0.00385951 6.38828 0.00466573 5.9168L-9.37535e-07 1.78112C-0.000709633 1.30864 0.194443 0.855309 0.542395 0.521155C0.890347 0.187001 1.3625 -0.000508469 1.85467 1.03561e-06H6.16067C6.65217 0.00114587 7.12338 0.188344 7.472 0.520962L15.4573 8.19328ZM3.53307 4.60808C4.26945 4.60808 4.86641 4.035 4.86641 3.32808C4.86641 2.62115 4.26945 2.04808 3.53307 2.04808C2.79669 2.04808 2.19974 2.62115 2.19974 3.32808C2.19974 4.035 2.79669 4.60808 3.53307 4.60808Z" />
    </svg>
  );
};

export default WoltSpecialIcon;
